/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : RecreateLinkDialog.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import React from "react";
import CustomDialogBoxV2 from "../../common/customDialogBox/CustomDialogBoxV2";
import AISuggestionHeader from "../../SmartMatchingDialogContainer/AiSuggestionHeader";
import { Box, IconButton, Typography } from "@mui/material";
import CustomDataGridV2 from "../../common/datagrid/CustomDataGridV2";
import helper from "../../../../utils/helper";
import CustomToolTip from "../../../infoButton/CustomToolTip";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

function RecreateLinkDialog({
  open,
  onClose,
  entity,
  linkList = [],
  handleLink,
}) {
  // functions
  const handleDialogClose = () => {
    onClose();
  };

  const getColumns = () => {
    return [
      {
        field: "component",
        headerName: "Component",
        minWidth: 320,
        flex: 1,
        sortable: false,
        renderCell: ({ value }) => {
          if (!value) return null;

          return (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
                height: "100%",
                width: "100%",
                flexDirection: "column",
              }}
            >
              <Typography variant="body2" color="text.primary">
                <strong>
                  {helper.toSentenceCase(value.primary?.key)}{" "}
                  {value.primary?.value}
                </strong>
              </Typography>

              {Array.isArray(value.secondary) &&
                value.secondary.map((item, index) => (
                  <Typography
                    key={index}
                    variant="body2"
                    color="text.secondary"
                  >
                    {helper.toSentenceCase(item.key)} {item.value}
                  </Typography>
                ))}
            </Box>
          );
        },
      },

      {
        field: "raw",
        headerName: "",
        minWidth: 180,
        sortable: false,
        align: "right",
        headerAlign: "right",
        renderCell: ({ value }) => {
          console.log("---render raw---", value);
          return (
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                height: "100%",
                width: "100%",
                pr: 2,
              }}
            >
              <CustomToolTip title={"Link"} type={"component"}>
                <IconButton
                  size="small"
                  onClick={() => handleLink(value)}
                  sx={{ color: "#000", ":hover": { color: "#26890D" } }}
                >
                  <AddCircleOutlineIcon fontSize="small" />
                </IconButton>
              </CustomToolTip>
            </Box>
          );
        },
      },
    ];
  };

  return (
    <CustomDialogBoxV2
      open={open}
      onClose={handleDialogClose}
      title="Recreate Link"
      requiresDefaultPaddingForContent={false}
      hideDefaultActions={true}
      dialogRadius="0rem"
      headerSlot={
        <AISuggestionHeader
          onClose={onClose}
          title={"Recreate Link"}
          showOnlyTitle={true}
        />
      }
    >
      <Box
        sx={{
          height: "360px",
          width: "650px",
          backgroundColor: "red",
        }}
      >
        <CustomDataGridV2
          rows={linkList}
          columns={getColumns()}
          hideHeader
          showPagination={false}
          isMultiLine={true}
          page={0}
          handlePageChange={() => { }}
        />
      </Box>
    </CustomDialogBoxV2>
  );
}

export default RecreateLinkDialog;
